enum PostHogEvent {
  PageView = "$pageview",
  DepositSuccess = "deposit_success",
  DepositFailure = "deposit_failure",
  WithdrawalSuccess = "withdrawal_success",
  WithdrawalFailure = "withdrawal_failure",
  PointsClaimSuccess = "points_claim_success",
  PointsClaimFailure = "points_claim_failure",
}

export default PostHogEvent
